import Immutable from "seamless-immutable";

const initialState = Immutable({});

const ServiceContentReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default ServiceContentReducer;
